import React, {useEffect, useState, ChangeEvent} from 'react';
import {InputText} from "primereact/inputtext";

interface INumberInputProps {
    value: number | undefined;
    placeholder?: string;
    decimalPlace?: number;
    suffix?: string

    onChange(val: number | undefined): void;
}

const InputNumber = ({
                         value: givenValue,
                         onChange,
                         placeholder = "",
                         decimalPlace = 2,
                         suffix = ""
                     }: INumberInputProps) => {
    const [value, setValue] = useState<string>("");
    const [cursorPosition, setCursorPosition] = useState<{ number: number | null }>({number: null});

    useEffect(() => {
        let val = givenValue?.toString()
        if (val) {
            setValue(addSuffix(val))
        } else {
            setValue("")
        }
    }, [givenValue])

    function removeDotsExceptFirst(str: string): string {
        let dotFound = false;
        let result = "";
        let count = 0;
        for (let i = 0; i < str.length; i++) {
            if (str[i] === ".") {
                if (!dotFound) {
                    result += ".";
                }
                dotFound = true;
            } else if (dotFound) {
                count++;
                if (count <= decimalPlace) {
                    if (str[i] === " " || parseFloat(str[i]) === null) {
                        break
                    }
                    result += str[i];
                } else {
                    break;
                }
            } else {
                result += str[i];
            }
        }
        return result;
    }

    const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
        let newValue = removeSuffix(e.target.value)
        if (newValue.split(".").length - 1 < 2) {

            if (newValue && newValue.length > 0 && newValue[0] === ".") {
                newValue = "0" + newValue
            }

            if (decimalPlace > 0) {
                setValue(removeDotsExceptFirst(newValue))
            } else {
                setValue(newValue.replaceAll(".", ""))
            }
        }
        setCursorPosition({number: e.target.selectionStart})
    }

    const parseValue = (valueString: string) => {
        const val = parseFloat(valueString)
        if (isNaN(val)) {
            return undefined
        }

        return val
    }

    const addSuffix = (value: string) => {
        return suffix ? (value && !value.includes(suffix) ? value + suffix : value) : value;
    }

    const removeSuffix = (value: string) => {
        return suffix ? value.replace(suffix, "") : value
    }

    return <InputText value={value}
                      keyfilter={"num"}
                      onChange={handleInputChange}
                      placeholder={placeholder}
                      onFocus={() => setValue(removeSuffix(value))}
                      onBlur={() => {
                          setValue(addSuffix(value))
                          onChange(parseValue(value))
                      }}
                      ref={input => input && (input.selectionStart = input.selectionEnd = cursorPosition.number)}
                      style={{width: "130px", padding: "6px 3px"}}
    />

}

export default InputNumber;